import { useSecureContext } from "../contexts/SecureContext";

interface ICurrencyProps {
    value: number;
    children: (value: string) => React.ReactNode;
    maximumFractionDigits?: number;
}

export default function Currency({ value, children, maximumFractionDigits = 2 }: ICurrencyProps) {
    const secureContext = useSecureContext();
    
    const formattedValue = Intl.NumberFormat(
            "pt-BR", 
            { 
                style: "currency", 
                currency: "BRL",
                minimumFractionDigits: 2,
                maximumFractionDigits: maximumFractionDigits
            }
        )
        .format(value ?? 0);

    return (
        <span>
            {
               children(secureContext.isSecure ? "R$ **" : formattedValue) 
            }
        </span>
    )
}
